import { LinkButton, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './EarlyAccessBanner.css';
import image from './assets/image.png';

interface IEarlyAccessBannerProps {
  title: string;
  subtitle: string;
  isEarlyAccessEnabled: boolean;
  listingUrl: string | null;
  onLinkClick: VoidFunction;
}

export const EarlyAccessBanner = React.forwardRef<HTMLDivElement, IEarlyAccessBannerProps>(function EarlyAccessBanner(
  { title, subtitle, listingUrl, onLinkClick },
  ref,
) {
  return (
    <div className={styles['container']} data-testid="EarlyAccessBanner" ref={ref}>
      <div className={styles['content']}>
        <div className={styles['content--text']}>
          <UIHeading2 fontWeight="700" whiteSpace="pre-wrap">
            {title}
          </UIHeading2>
          <UIText1 whiteSpace="pre-wrap">{subtitle}</UIText1>
        </div>
        {listingUrl && (
          <div>
            <LinkButton href={listingUrl} theme="fill_primary" size="XS" onClick={onLinkClick}>
              Показать вcе в раннем доступе
            </LinkButton>
          </div>
        )}
      </div>
      <img src={image} className={styles['image']} />
    </div>
  );
});
